// undoToast — the app-level store behind <UndoToast/> (src/components/UndoToast.tsx).
//
// One toast at a time. showUndo() REPLACES the current one: the old toast's
// onUndo is dropped, never called. The toast lives at app level (not in the
// page) because the row it refers to has just left the page's list.
//
//   showUndo({ message: 'Seed deleted', onUndo: () => restore() })
//
// The timer lives in the component (it pauses on hover / focus); this file is
// only the state, so it needs no React and is trivial to test.

export const UNDO_TOAST_MS = 6000

export interface UndoToastState {
  /** Changes on every showUndo(), so the component restarts its timer. */
  id: number
  message: string
  onUndo: () => void | Promise<void>
}

let current: UndoToastState | null = null
let nextId = 1
const listeners = new Set<() => void>()

function emit() { for (const l of [...listeners]) l() }

export function showUndo(opts: { message: string; onUndo: () => void | Promise<void> }): void {
  current = { id: nextId++, message: opts.message, onUndo: opts.onUndo }
  emit()
}

export function dismissUndo(): void {
  if (!current) return
  current = null
  emit()
}

export function getUndoToast(): UndoToastState | null { return current }

export function subscribeUndoToast(l: () => void): () => void {
  listeners.add(l)
  return () => { listeners.delete(l) }
}
